export type IODataType = 'text' | 'image' | 'file' | 'audio' | 'bool';

export type IOInfo = { name?: string; data_types: IODataType[] };

export type NodeDataType = {
  inputs: IOInfo[];
  outputs: IOInfo[];
};

export const allDataTypes: IODataType[] = [];
